import React, { useMemo, useState } from 'react';
import { FlatList, Platform, TextInput, TouchableOpacity, View, Text } from 'react-native';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import { BottomBarDLSType, ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconTokens, TypographyTypeDLS } from '@voltmoney/schema';
import CustomHeader from '../../customHeader/CustomHeader';
import NeedHelpDC from '../NeedHelpDC';
import Typography from '../../typography/Typography';
import * as Animatable from 'react-native-animatable';
import Icon from '../../icon/Icon';
import BottomSheetMfAnimation from '../../bottomSheetMfAnimation/BottomSheetMfAnimation';
import { BottomSheetAnimation } from '../../bottomSheetMF/bottomSheetMf';
import Button from '../../button/Button';
import BottomBar from '../../bottomBarDLS/bottomBarDLS';
import { addCommasToNumber } from '../utils';
import { FAQ_TYPE, REPAY_TITLE } from '../constants';
const FaqDetails = ({ height, contactUsDetails, goBackAction, title, data, interestDueDate, navigateToPayment, navigateToForeclosureScreen, creditLimit, interestRate, triggerAction, trackFaqInstrumentAction, }) => {
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    const [openFeedbackCard, setOpenFeedbackCard] = useState(false);
    const [feedbackInput, setFeedbackInput] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [isQueryResolved, setQueryResolved] = useState(false);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { title: 'FAQs', needHelpAction: handleNeedHelp, goBackAction: goBackAction, triggerAction: triggerAction, showNeedHelpNewArch: true }));
    }, []);
    const handleCloseModal = () => {
        setOpenFeedbackCard(false);
    };
    const handleAccountClosure = async () => {
        await triggerAction(navigateToForeclosureScreen);
    };
    const renderCommonComp = () => {
        return (React.createElement(View, { style: { marginTop: 24 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night, label: 'Was your query answered?' }),
            isQueryResolved ? (React.createElement(View, { style: { backgroundColor: '#E7EBFA', borderRadius: 8, paddingHorizontal: 12, paddingVertical: 8, flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', marginTop: 12 } },
                React.createElement(Icon, { name: IconTokens.SMILE_FACE_ICON }),
                React.createElement(View, { style: { marginLeft: 8 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Primary_100, label: 'Thanks for your feedback' })))) : (React.createElement(View, { style: { marginTop: 12, flexDirection: 'row' } },
                React.createElement(TouchableOpacity, { onPress: async () => {
                        setQueryResolved(true);
                        await triggerAction({
                            ...trackFaqInstrumentAction,
                            payload: {
                                type: 'FAQ_QUERY_RESOLVED',
                                eventProverty: 'result',
                                result: 'yes',
                                question: title,
                                ...trackFaqInstrumentAction.payload
                            }
                        });
                    }, style: { marginRight: 8, paddingHorizontal: 12, paddingVertical: 8, borderRadius: 8, borderWidth: 1, borderColor: '#E4E7EC', flexDirection: 'row', alignItems: 'center' } },
                    React.createElement(Icon, { name: IconTokens.YES_ICON }),
                    React.createElement(View, { style: { marginLeft: 4 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, label: 'Yes' }))),
                React.createElement(TouchableOpacity, { style: { marginRight: 8, paddingHorizontal: 12, paddingVertical: 8, borderRadius: 8, borderWidth: 1, borderColor: '#E4E7EC', flexDirection: 'row', alignItems: 'center' }, onPress: async () => {
                        setOpenFeedbackCard(true);
                        await triggerAction({
                            ...trackFaqInstrumentAction,
                            payload: {
                                type: 'FAQ_QUERY_RESOLVED',
                                eventProverty: 'result',
                                result: 'No',
                                question: title,
                                ...trackFaqInstrumentAction.payload
                            }
                        });
                    } },
                    React.createElement(Icon, { name: IconTokens.NO_ICON }),
                    React.createElement(View, { style: { marginLeft: 4 } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, label: 'No' })))))));
    };
    const renderModalBottomCard = () => {
        return (React.createElement(View, { style: { paddingHorizontal: 16, paddingBottom: 16 } },
            React.createElement(Button, { label: 'Submit', typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, onPress: async () => {
                    setQueryResolved(true);
                    setOpenFeedbackCard(false);
                    await triggerAction({
                        ...trackFaqInstrumentAction,
                        payload: {
                            type: 'FAQ_NO_REASON',
                            eventProverty: 'remarks',
                            question: title,
                            result: feedbackInput,
                            ...trackFaqInstrumentAction.payload
                        }
                    });
                } })));
    };
    const renderModal = () => {
        return (React.createElement(View, { style: { flex: 1 } },
            React.createElement(Typography, { label: 'Help us improve', typeDLS: TypographyTypeDLS.H3S, color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { flex: 1, marginTop: 16 } },
                React.createElement(TextInput, { style: [
                        { width: "100%", borderWidth: 1, borderColor: isFocused ? '#E4E7EC' : "#E4E7EC",
                            borderRadius: 4, paddingVertical: 12, paddingLeft: 16, paddingRight: 12, fontSize: 14, overflow: 'hidden',
                            color: feedbackInput?.length > 0 ? '#1D2939' : '#98A2B3', textAlignVertical: "top", height: 120 },
                        Platform.OS === 'web' && {
                            //@ts-ignore
                            outlineStyle: 'none',
                        },
                    ], value: feedbackInput, onChangeText: setFeedbackInput, placeholder: "Tell us what you didn\u2019t understand in the article", maxLength: 500, multiline: true, onFocus: () => {
                        setIsFocused(true);
                    }, onBlur: () => setIsFocused(false) }))));
    };
    const footerChild = () => {
        return (React.createElement(BottomSheetMfAnimation, { animationType: BottomSheetAnimation.NONE, bottomChild: renderModalBottomCard(), modalVisible: openFeedbackCard, onModalClose: handleCloseModal }, renderModal()));
    };
    const renderOrder = [];
    Object.keys(data).forEach((key) => {
        if (data[key] && Array.isArray(data[key]) && data[key].length > 0) {
            renderOrder.push(key);
        }
    });
    const handlePress = async (title) => {
        await triggerAction(navigateToPayment);
    };
    const replacePlaceholders = (subtitle) => {
        let formattedText = subtitle.replace("{{InterestDueDate}}", interestDueDate);
        formattedText = formattedText.replace("{{creditLimit}}", addCommasToNumber(creditLimit));
        formattedText = formattedText.replace("{{interestRate}}", interestRate);
        return formattedText;
    };
    const nestedDescription = () => {
        return (React.createElement(FlatList, { data: data?.nestedDescription, keyExtractor: (item, index) => `nested-${index}`, renderItem: ({ item }) => {
                const updatedSubtitle = replacePlaceholders(item?.subtitle);
                return (React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { marginRight: 4, marginTop: 12, alignItems: 'center' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, label: `\u2022` })),
                    React.createElement(Text, { style: { flexDirection: 'row', flexWrap: 'wrap', marginTop: 12, flex: 1, alignItems: 'center' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, label: `${item?.title} ` }),
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: updatedSubtitle }))));
            } }));
    };
    const renderDescription = () => {
        return (React.createElement(FlatList, { data: data?.descriptions, keyExtractor: (item, index) => `desc-${index}`, renderItem: ({ item }) => {
                const updatedSubtitle = replacePlaceholders(item?.description);
                return (React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: updatedSubtitle === REPAY_TITLE.REAPAY_YOUR_DUES ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal, label: updatedSubtitle })));
            } }));
    };
    const renderExample = () => {
        return (React.createElement(FlatList, { data: data.examples, keyExtractor: (item, index) => `example-${index}`, renderItem: ({ item }) => {
                const updatedSubtitle = replacePlaceholders(item?.subtitle);
                return (React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0B, color: ColorTokens.Grey_Night, label: item?.title }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: updatedSubtitle })));
            } }));
    };
    const renderArrayExamples = () => {
        return (React.createElement(View, { style: { marginTop: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night, label: 'Example:' }),
            React.createElement(FlatList, { data: data.arrayExamples, keyExtractor: (item, index) => `example-${index}`, renderItem: ({ item }) => (React.createElement(View, { style: { marginLeft: 4 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: `- ${item?.subtitle}` }))) })));
    };
    const renderNestedExampleDescription = () => {
        return (React.createElement(View, { style: { marginTop: 16 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, color: ColorTokens.Grey_Night, label: data.nestedExampleDescription[0].title }),
            React.createElement(FlatList, { data: data.nestedExampleDescription, keyExtractor: (item, index) => `example-${index}`, renderItem: ({ item }) => (React.createElement(View, { style: { marginLeft: 4 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: `- ${item?.subtitle}` }))) })));
    };
    const renderOtherDescription = () => {
        return (React.createElement(FlatList, { data: data?.otherDescriptions, keyExtractor: (item, index) => `desc-${index}`, renderItem: ({ item }) => (React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: item?.description }))) }));
    };
    const renderBottomModal = () => {
        return (React.createElement(View, { style: { flex: 1, justifyContent: 'flex-end' } },
            React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_B, isPositionAbsolute: false, btnLabel: `Proceed to close account`, btnTypeDLS: ButtonTypeDLS.SECONDARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, isDisabled: false, onPress: handleAccountClosure })));
    };
    const renderCloseAccountDetails = () => {
        return (React.createElement(FlatList, { data: data?.closeAccount, keyExtractor: (item, index) => `desc-${index}`, renderItem: ({ item }) => {
                const updatedSubtitle = replacePlaceholders(item?.description);
                return (React.createElement(View, { style: { flexDirection: 'row' } },
                    React.createElement(View, { style: { marginRight: 4, marginTop: 16, alignItems: 'center' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Night, label: `\u2022` })),
                    React.createElement(Text, { style: { flexDirection: 'row', flexWrap: 'wrap', marginTop: 16, flex: 1, alignItems: 'center' } },
                        React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, color: ColorTokens.Grey_Charcoal, label: updatedSubtitle }))));
            } }));
    };
    const renderButtonModal = () => {
        return (React.createElement(View, { style: { flex: 1, justifyContent: 'flex-end' } },
            React.createElement(BottomBar, { typeDLS: BottomBarDLSType.TYPE_B, isPositionAbsolute: false, btnLabel: data?.button[0]?.title, btnTypeDLS: ButtonTypeDLS.SECONDARY, btnSizeDLS: ButtonSizeDLS.MEDIUM, isDisabled: false, onPress: handlePress })));
    };
    const renderData = (type) => {
        if (type === FAQ_TYPE.NESTED_DESCRIPTION) {
            return nestedDescription();
        }
        else if (type === FAQ_TYPE.DESCRIPTIONS) {
            return renderDescription();
        }
        else if (type === FAQ_TYPE.EXAMPLES) {
            return renderExample();
        }
        else if (type === FAQ_TYPE.ARRAY_EXAMPLES) {
            return renderArrayExamples();
        }
        else if (type === FAQ_TYPE.NESTED_EXAMPLE_DESCRIPTION) {
            return renderNestedExampleDescription();
        }
        else if (type === FAQ_TYPE.OTHER_DESCRIPTIONS) {
            return renderOtherDescription();
        }
        else if (type === FAQ_TYPE.CLOSE_ACCOUNT) {
            return renderCloseAccountDetails();
        }
    };
    const renderContent = () => {
        return (React.createElement(Animatable.View, { animation: 'fadeIn', delay: 100, duration: 1000, style: { flex: 1 } },
            React.createElement(View, { style: { marginTop: 24, paddingHorizontal: 16, paddingBottom: 16, flex: 1, } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B0S, color: ColorTokens.Grey_Night, label: title }),
                renderOrder.map((type) => renderData(type)),
                !renderOrder.includes(FAQ_TYPE.CLOSE_ACCOUNT) && renderCommonComp())));
    };
    return (React.createElement(BoilerPlate, { height: height, headerChild: headerChild, backgroundColor: ColorTokens.White, heightHeader: Platform.OS === 'ios' ? 93 : 57, bottomChildren: React.createElement(React.Fragment, null,
            showNeedHelp && (React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails })),
            footerChild(),
            renderOrder.includes(FAQ_TYPE.CLOSE_ACCOUNT) && renderBottomModal(),
            renderOrder.includes(FAQ_TYPE.BUTTON) && renderButtonModal()) },
        React.createElement(React.Fragment, null, renderContent())));
};
export default FaqDetails;
